import {HubApiRequest} from '../hub-api-request';
import {HubMethod} from '../constants/methods';
import {v4 as uuidv4} from 'uuid';
import {RequestEmailOtpRegRequest, RequestEmailOtpResponse} from '../protocol/registration-otp-req';

export class RequestEmailOtpRegister extends HubApiRequest<RequestEmailOtpRegRequest, RequestEmailOtpResponse> {
    constructor(url: string, deviceIdentifier: string, data: RequestEmailOtpRegRequest) {
        super(url, HubMethod.REQUEST_EMAIL_OTP_REG, deviceIdentifier, data, uuidv4());
    }
}
